import React, { useEffect, useState } from "react";
import Breadcrums from "../../../components/breadcrums";
import PageTitle from "../../../components/pageTitle";
import { paymentsGenerateInvoiceBreadcrums } from "../../../constants/breadcrums";
import { paymentsCommands, sectionClass } from "../../../constants/common";
import CommonFilters from "../../../blocks/commonFilters";
import { useSnackbar } from "react-simple-snackbar";
import { listOfEmployees, listOfEmployeesByClient, listOfEmployeesByVendor } from "../../../api/consultants-api";
import TanstackTable from "../../../components/TanstackTable";
import { ColumnDef } from "@tanstack/react-table";
import { generateCustomizedInvoice, generateInvoice, generateWeeklyInvoice, getDuplicateInvoiceNumber, getInvoicesData, markVerified, performPaymentAPI, resetInvoice } from "../../../api/finance-api";
import { GetClients, GetVendors } from "../../../api/project-api";
import Currency from "react-currency-formatter";
import moment from "moment";
// import { generate } from "@pdfme/generator";
import { FinanceRecord, InvoiceRequestParams } from "../../../model";
import { ExclamationCircleIcon } from "@heroicons/react/solid";
// import ToolTip from "../../../components/ToolTip";

import { NumericFormat } from "react-number-format";

import { Tooltip } from "flowbite-react";
import { getNextInvoiceNumber } from "../../../api/sequence-api";
import { useAuth0 } from "@auth0/auth0-react";
import { nanoid } from "nanoid";
import OverdueEmail from "../../../components/overdue-email";
import UnpaidEmail from "../../../components/unpaid-email";
import logger from "../../../utils/logger";

// Use current year for calculation
// const workingDaysPerMonth: number[] = getWorkingDaysPerMonth(new Date().getFullYear());
// console.log(workingDaysPerMonth);

export default function Invoices() {
    const [people, setPeople] = useState<{ entity: string; active?: number }[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [vendors, setVendors] = useState<any[]>([]);
    const [openSnackbar] = useSnackbar();
    const [isLoading, setLoading] = React.useState(false);
    const [filter, setFilter] = React.useState(null);
    const [data, setData] = React.useState<FinanceRecord[]>([]);
    const [activeStatus, setActiveStatus] = useState<"all" | "active" | "inactive">("all");
    const [billingPeriod, setBillingPeriod] = useState<"all" | "Weekly" | "Monthly" | "Monthly Itemized" | "Customized">("all");
    const [applyYearFilter, setApplyYearFilter] = useState(true);
    const [duplicateInvoices, setDuplicateInvoices] = useState<any[]>([]);
    const [showUnpaidOnly, setShowUnpaidOnly] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState<string>("all");
    const [showAgingInRedOnly, setShowAgingInRedOnly] = useState(false);

    const { user, isAuthenticated } = useAuth0(); // <-- Call hook here

    const [tableKey, setTableKey] = useState("initial");
    const [sendingEmails, setSendingEmails] = useState(false);

    function forceTableRefresh() {
        setTableKey(nanoid());
    }

    async function handleSendOverdueEmails() {
        setSendingEmails(true);
        try {
            // Filter overdue invoices and send them
            // const result = await (sendOverdueReminders as any)(filteredData);
            // openSnackbar(result.message);
        } catch (error) {
            openSnackbar("Error sending emails");
        } finally {
            setSendingEmails(false);
        }
    }

    // Load clients, vendors and employees on mount
    useEffect(() => {
        setLoading(true);
        setPeople([]);
        setData([]);
        Promise.all([GetClients(), GetVendors()])
            .then(([clients, vendors]) => {
                setClients(clients);
                setVendors(vendors);
                // Default: load all employees
                return listOfEmployees();
            })
            .then((employees) => {
                setPeople(employees);
                // Prepare default filter (no checkDate by default)
                const defaultFilters = {
                    checkDate: new Date(),
                    employee: "",
                    vendorId: "all",
                    groupedUUID: false,
                    employeeStatus: "all",
                    billingPeriod: "all",
                    yearLimit: true,
                };
                applyFilters(defaultFilters);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    // When vendor filter changes, update employees list
    useEffect(() => {
        if (!selectedVendor || selectedVendor === "all") {
            listOfEmployees().then(setPeople);
        } else {
            listOfEmployeesByVendor(selectedVendor).then(setPeople);
        }
    }, [selectedVendor]);

    function applyFilters(filters): any {
        setLoading(true);
        setData([]);
        setFilter(filters);

        console.log("^^^^^^^^^^^^");

        console.log("Applying filters:", filters);

        getDuplicateInvoiceNumber()
            .then((data) => {
                setDuplicateInvoices(data || []);
                if (data && data.length > 0) {
                    openSnackbar("Duplicate Invoice Numbers found!");
                }
            })
            .catch((error) => {
                setDuplicateInvoices([]);
                logger.error("Error fetching duplicate invoice numbers:", error);
            });

        getInvoicesData(filters)
            .then((data) => {
                // console.log(data);
                console.log("Invoice data loaded:", data);
                console.log("Sample row:", data[0]);
                setData(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    async function generateInvoiceHandler(params: InvoiceRequestParams): Promise<any> {
        const invoiceNo = await getNextInvoiceNumber();
        console.log(invoiceNo); // e.g., "20250729-001"
        //nextId("INV" + moment.utc().format("YYMMDD-"));
        //nextId("INV" + moment.utc().format("YYMMDD-"));
        params.invoiceNo = invoiceNo;

        const scrollY = window.scrollY;

        console.log("Generating invoice with params:", params);

        // Audit Details
        try {
            // Get current user from Auth0
            let currentUser = "system";
            if (isAuthenticated && user) {
                currentUser = user.name || user.email || "system"; //user.nickname ||
            }

            // Audit Details
            // params.createdBy = currentUser;
            params.updatedBy = currentUser;
        } catch (error) {
            logger.error("Error fetching user details:", error);
            params.createdBy = "system"; // Fallback if user details are not available
            params.updatedBy = "system";
        }

        if (params.billingPeriod === "Monthly" || params.billingPeriod === "Monthly Itemized") {
            params.invoiceNo = invoiceNo;
            generateInvoice(params).then((updatedRows: any[]) => {
                console.log(updatedRows);

                // Optimistically update local data state
                setData((prevData) =>
                    prevData.map((item) => {
                        console.log("Processing item:", item);
                        const updated = (updatedRows as any[]).find((u: any) => u.uuid === item.uuid && params.startDate === item.period_start);
                        if (updated) {
                            const merged = { ...item, ...updated };
                            console.log("Updated item:", merged);
                            return merged;
                        }
                        return item;
                    }),
                );

                if (params.uuid) {
                    openSnackbar("Invoice Generated");
                } else {
                    openSnackbar("Invoices Generated");
                }

                forceTableRefresh();

                // After update (in a setTimeout or useEffect)
                setTimeout(() => {
                    window.scrollTo(0, scrollY);
                }, 0);
            });
        } else if (params.billingPeriod === "Weekly") {
            params.invoiceNo = invoiceNo;

            generateWeeklyInvoice(params).then((r) => {
                console.log(r);
                // getInvoiceSequence();

                // Optimistically update local data state
                setData((prevData) =>
                    prevData.map((item) =>
                        item.uuid === params.uuid && Number(item.calendar_week) === params.week && item.year === moment(params.checkDate).year()
                            ? {
                                  ...item,
                                  invoice_no: params.invoiceNo || "",
                                  _ts_invoice: new Date(), // or the correct value if you have it
                                  // update other fields if needed
                              }
                            : item,
                    ),
                );

                openSnackbar("Weekly Invoice(s) Generated");

                forceTableRefresh();

                // After update (in a setTimeout or useEffect)
                setTimeout(() => {
                    window.scrollTo(0, scrollY);
                }, 0);
            });
        } else if (params.billingPeriod === "Customized") {
            params.invoiceNo = invoiceNo;

            // Record Dates Range
            params.record_st_dt = moment(params.record_st_dt).format("YYYY-MM-DD");
            params.record_end_dt = moment(params.record_end_dt).format("YYYY-MM-DD");

            generateCustomizedInvoice(params)
                .then((updatedRows: any) => {
                    // Defensive: handle null, undefined, or error object
                    if (!Array.isArray(updatedRows)) {
                        logger.error("generateCustomizedInvoice did not return an array:", updatedRows);
                        openSnackbar("Please apply filters, to see the status.");
                        return;
                    }
                    console.log(updatedRows);

                    // Optimistically update local data state
                    setData((prevData) =>
                        prevData.map((item) => {
                            console.log("Processing item:", item);
                            const updated = updatedRows.find((u: any) => u.uuid === item.uuid && params.startDate === item.period_start);
                            if (updated) {
                                const merged = { ...item, ...updated };
                                console.log("Updated item:", merged);
                                return merged;
                            }
                            return item;
                        }),
                    );

                    if (params.uuid) {
                        openSnackbar("Invoice Generated");
                    } else {
                        openSnackbar("Invoices Generated");
                    }

                    forceTableRefresh();

                    // After update (in a setTimeout or useEffect)
                    setTimeout(() => {
                        window.scrollTo(0, scrollY);
                    }, 0);
                })
                .catch((err) => {
                    logger.error("generateCustomizedInvoice failed:", err);
                    openSnackbar("Error generating customized invoice");
                });
        }
    }

    // Move these functions INSIDE the component
    function performVerify(params: InvoiceRequestParams): any {
        params.verified = true;
        params._ts_verify = new Date();

        // Audit Details
        try {
            // Get current user from Auth0
            let currentUser = "system";
            if (isAuthenticated && user) {
                currentUser = user.name || user.email || "system"; //user.nickname ||
            }

            // Audit Details
            // params.createdBy = currentUser;
            params.updatedBy = currentUser;
        } catch (error) {
            logger.error("Error fetching user details:", error);
            params.createdBy = "system"; // Fallback if user details are not available
            params.updatedBy = "system";
        }

        markVerified(params).then((r) => {
            openSnackbar("Verified Successfully");
            // Optionally refresh data here
        });
    }

    function performPayment(params: InvoiceRequestParams): any {
        // console.log(params);
        // params.verified = true;
        // params._ts_verify = new Date();

        // Set payment to bill amount for UI update, without disturbing API logic
        if (params && params.record) {
            let billAmount = 0;
            if (params.record.billing_period === "Customized") {
                const prate = Number(params.record.prate) || 0;
                const hrs = Number(params.record.hrs) || 0;
                billAmount = prate * hrs;
            } else {
                billAmount = Number(params.record.bill) || 0;
            }
            if (Number(params.record.over_time) > 0) {
                billAmount += (Number(params.record.overtime_hours) || 0) * (Number(params.record.over_time_rate) || 0);
            }
            params.payment = billAmount;
            // Do not set params.diff, as it does not exist on InvoiceRequestParams
        }

        // Audit Details
        try {
            // Get current user from Auth0
            let currentUser = "system";
            if (isAuthenticated && user) {
                currentUser = user.name || user.email || "system"; //user.nickname ||
            }

            // Audit Details
            // params.createdBy = currentUser;
            params.updatedBy = currentUser;
        } catch (error) {
            logger.error("Error fetching user details:", error);
            params.createdBy = "system"; // Fallback if user details are not available
            params.updatedBy = "system";
        }

        performPaymentAPI(params).then((r) => {
            openSnackbar("Payment Completed.");
            // Refetch so the Balance column reflects the recorded payment (including sales tax).
            applyFilters(filter || { checkDate: new Date() });
        });
    }

    // The value shown in the "Bill Amount" column for a given row.
    const getRowBaseBillAmount = (row: FinanceRecord): number => {
        if (row.billing_period === "Customized") {
            return (Number(row.prate) || 0) * (Number(row.hrs) || 0);
        }
        return Number(row.bill) || 0;
    };

    // Overtime hours = sum over days of max(0, hrs - 8), only when the project has Over Time applicable.
    const getRowOverTimeHours = (row: FinanceRecord): number => (Number(row.over_time) > 0 ? Number(row.overtime_hours) || 0 : 0);

    const getRowOverTimeRate = (row: FinanceRecord): number => (Number(row.over_time) > 0 ? Number(row.over_time_rate) || 0 : 0);

    // Overtime amount = overtime hours x overtime rate.
    const getRowOverTimeAmount = (row: FinanceRecord): number => getRowOverTimeHours(row) * getRowOverTimeRate(row);

    // Bill amount shown on the payments tab = existing bill amount + overtime amount.
    const getRowBillAmount = (row: FinanceRecord): number => getRowBaseBillAmount(row) + getRowOverTimeAmount(row);

    // Same calculation as the generated invoice: bill * rate / 100.
    // Sales tax only applies when the employee is on fixed payroll and a rate is configured.
    const getRowSalesTax = (row: FinanceRecord): number => {
        const rate = Number(row.sales_tax) || 0;
        if (rate <= 0 || !(Number(row.fixed_payroll) > 0)) {
            return 0;
        }
        return (getRowBaseBillAmount(row) * rate) / 100;
    };

    // Balance = (Bill Amount including sales tax) - amount received.
    const getRowBalance = (row: FinanceRecord): number => {
        const payment = Number(row.payment) || 0;
        const balance = Number((getRowBillAmount(row) + getRowSalesTax(row) - payment).toFixed(2));
        // Ignore sub-cent rounding drift from per-day payment allocation.
        return Math.abs(balance) <= 0.05 ? 0 : balance;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const columns = React.useMemo<ColumnDef<FinanceRecord, any>[]>(
        () => [
            {
                accessorKey: "name",
                header: "Name",
                // cell: (info) => info.getValue(),
                cell: ({ row }) => {
                    const client = clients.find((c) => String(c.id) === String(row.original.cid));
                    const vendor = client?.vendor || "-";
                    return (
                        <>
                            <span className="font-bold">{row.original.name}</span> <br />
                            <span className="text-xs">{" (" + vendor + ")"}</span>
                        </>
                    );
                },
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                meta: {
                    cellClassName: "font-bold",
                    className: "font-bold",
                },
                footer: ({ table }) => (
                    <>
                        <span className="font-semibold text-md">Total</span>
                        <br />
                        <span className="text-xs text-gray-600">{new Set(table.getFilteredRowModel().rows.map((row) => row.original.name)).size} employees</span>
                    </>
                ),
            },
            // --- Add this new column below ---
            // FIXME - Hide for now
            // {
            //     accessorKey: "billing_group",
            //     header: "Billing Cycle",
            //     cell: ({ row }) => row.original.billing_period ||  "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            // {
            //     accessorKey: "_d",
            //     header: "D",
            //     cell: ({ row }) => row.original._d || "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            // {
            //     accessorKey: "calendar_week",
            //     header: "Week No.",
            //     cell: ({ row }) => row.original.calendar_week || "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            {
                accessorKey: "period_start",
                header: "Period Start",
                cell: ({ row }) => {
                    const value = row.original.period_start;
                    return value ? moment(value).format("YYYY-MM-DD") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-left",
                },
            },

            {
                accessorKey: "record_st_dt",
                header: "Record Start",
                cell: ({ row }) => {
                    const value = row.original.record_st_dt || row.original.period_start;
                    return value ? moment(value).format("YYYY-MM-DD") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-left",
                },
            },

            {
                accessorKey: "record_end_dt",
                header: "Record End",
                cell: ({ row }) => {
                    const value = row.original.record_end_dt || row.original.period_end;
                    return value ? moment(value).format("YYYY-MM-DD") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-left",
                },
            },

            // {
            //     accessorKey: "period_end",
            //     header: "Period End",
            //     cell: ({ row }) => moment(row.original.period_end).format("YYYY-MM-DD") || "-",
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-left",
            //     },
            // },

            {
                accessorKey: "month",
                header: "Invoice Period",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <></>,
            },

            // {
            //     accessorKey: "_ts_invoice_due",
            //     header: "Aging",
            //     cell: ({ row, getValue }) => {
            //         const dueDate = getValue();
            //         if (!row.original.invoice_no) return "-";
            //         if (!dueDate) return "-";
            //         const days = moment().diff(moment(dueDate), "days");
            //         const isOverdue = days >= 0;
            //         return (
            //             <span style={{ color: isOverdue ? "red" : "black" }}>
            //                 {isOverdue
            //                     ? `${days} day${days === 1 ? "" : "s"}`
            //                     : `Due in ${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"}`}
            //             </span>
            //         );
            //     },
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     enableSorting: true,
            //     footer: ({ table }) => <></>,
            // },

            {
                accessorKey: "_ts_invoice_due",
                header: "Aging",
                cell: ({ row, getValue }) => {
                    // Only show if diff > 0 and invoice_no exists
                    if (!row.original.invoice_no || !(row.original.diff > 0)) return "-";
                    const dueDate = getValue();
                    if (!dueDate) return "-";
                    const days = moment().diff(moment(dueDate), "days");
                    const isOverdue = days >= 0;
                    return <span style={{ color: isOverdue ? "red" : "black" }}>{isOverdue ? `${days} day${days === 1 ? "" : "s"}` : ` ${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"}`}</span>;
                },
                enableColumnFilter: false,
                enableGrouping: false,
                enableSorting: true,
                footer: ({ table }) => <></>,
            },

            // FIXME - Hide for now
            {
                accessorKey: "_punched",
                header: "Punched (Days)",
                cell: (info) => info.getValue(),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <></>,
            },

            // {
            //     accessorKey: "month",
            //     header: "Working Days",
            //     // cell: (info) => info.getValue(),
            //     cell: ({ row, getValue }) => {
            //         const date = moment(row.original._d);
            //         const year = date.year();
            //         const month = date.month(); // 0-based
            //         return getWorkingDaysPerMonth(year)[month] || "-";
            //         // return getEffortsDetails(row?.original) || "-";
            //     },
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // enableSorting: true,
            //     footer: ({ table }) => <></>,
            // },

            // {
            //     accessorKey: "_d",
            //     header: "D",
            //     cell: (info) => info.getValue(),
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // enableSorting: true,
            //     footer: ({ table }) => <></>,
            // },

            // {
            //     accessorKey: "billing_period",
            //     header: "Invoice Period",
            //     cell: ({ row }) => (
            //         <>
            //             {row.original.billing_period != "Weekly" && moment(row.original._d).format("MMM-YYYY")}
            //             {row.original.billing_period == "Weekly" && row.original.invoice_no == "" && moment(row.original._d).format("MMM-YYYY")}
            //             {row.original.billing_period == "Weekly" && row.original.invoice_no != "" && "Week-" + moment(row.original._d).week()}
            //         </>
            //     ),
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // enableSorting: true,
            //     footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            // },

            {
                accessorKey: "hrs",
                header: "Efforts (Hrs)",
                cell: (info) => Number(info.getValue()).toFixed(2),
                enableGrouping: false,
                enableColumnFilter: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <>
                        {/* <span className="text-xs font-normal">Total Efforts</span>
                        <br /> */}
                        {/* <span className="text-md thousand-sepera">{table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.hrs, 0)}</span> */}
                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.hrs, 0)) || 0}  displayType={'text'}  thousandSeparator="," /> */}
                        <NumericFormat value={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.hrs, 0)) || 0} allowLeadingZeros displayType="text" thousandSeparator="," />
                    </>
                ),
            },

            {
                accessorKey: "prate",
                header: "Rate (USD)",
                // cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                cell: ({ row, getValue }) => {
                    if (row.original.fixed_payment) return <>{<Currency quantity={Number(row.original.fixed_payment) || 0} currency="USD" />} /m</>;
                    //Number(row.original.fixed_payment) ||

                    const rate = getValue();
                    return rate != null && rate !== '' ? <Currency quantity={Number(rate) || 0} currency="USD" /> : "-";
                },
                enableGrouping: false,
                enableColumnFilter: false,
                meta: {
                    cellClassName: "text-right",
                },
            },

            // {
            //     accessorKey: "uuid",
            //     header: "UUID",
            //     cell: (info) => info.getValue(),
            //     // enableHiding: false,
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // columnVisibility: false,
            //     meta: {
            //         cellClassName: "text-center",
            //     },
            // },

            {
                accessorKey: "deductions",
                header: "Deductions (%)",
                cell: ({ row }) => {
                    const insuranceFee = Number((row.original as any).insurance_fee) || 0;
                    const vmo = Number((row.original as any).vmo) || 0;
                    const totalDeductions = insuranceFee + vmo;
                    return <span>{totalDeductions}%</span>;
                },
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
            },

            // {
            //     accessorKey: "deductions",
            //     header: "Deduction Amount (USD)",
            //     cell: ({ row }) => {
            //         const insuranceFee = Number((row.original as any).insurance_fee) || 0;
            //         const vmo = Number((row.original as any).vmo) || 0;

            //         const totalDeductions = insuranceFee + vmo;

            //         return <span>{row.original.bill_wo_deductions * totalDeductions / 100}</span>;
            //     },
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     meta: {
            //         cellClassName: "text-right",
            //     },

            // },

            // {
            //     accessorKey: "bill_wo_deductions",
            //     header: "Bill Amount w/o Deductions (USD)",
            //     cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
            //     // cell: ({ row }) => (
            //     //     <><Currency quantity={row.original.bill || 0} currency="USD" /> </>
            //     // ),
            //     // enableHiding: false,
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // columnVisibility: false,
            //     meta: {
            //         cellClassName: "text-right",
            //     },
            //     footer: ({ table }) => (
            //         <>
            //             {/* <span className="text-xs font-normal">Total Bill</span>
            //             <br /> */}
            //             {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + (row.original.fixed_payroll ? (Number(row.original.fixed_payroll) / getWorkingDaysPerMonth(moment(row.original._d).year())[Number(moment(row.original?._d).month() - 1)]) * Number(row.original?._punched) : row.original.bill), 0)) || 0} currency="USD" /> */}

            //             {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.bill, 0)) || 0} currency="USD" /> */}

            //             <Currency
            //                 quantity={table
            //                     .getFilteredRowModel()
            //                     .rows.map((row) => Number(row.original.bill_wo_deductions || 0))
            //                     .filter((val) => !isNaN(val))
            //                     .reduce((total, val) => total + val, 0)}
            //                 currency="USD"
            //             />
            //         </>
            //     ),
            // },

            {
                accessorKey: "overtime_hours",
                header: "Overtime efforts (Hrs)",
                cell: ({ row }) => (Number(row.original.over_time) > 0 ? <span>{getRowOverTimeHours(row.original)}</span> : <span className="text-gray-400">-</span>),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => {
                    const total = table.getFilteredRowModel().rows.reduce((sum, row) => sum + getRowOverTimeHours(row.original), 0);
                    return <span>{total}</span>;
                },
            },

            {
                accessorKey: "overtime_rate",
                header: "Overtime rate (USD)",
                cell: ({ row }) => (Number(row.original.over_time) > 0 ? <Currency quantity={getRowOverTimeRate(row.original)} currency="USD" /> : <span className="text-gray-400">-</span>),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
            },

            {
                accessorKey: "sales_tax",
                header: "Sales Tax (USD)",
                cell: ({ row }) => {
                    const rate = Number(row.original.sales_tax) || 0;
                    if (rate <= 0 || !(Number(row.original.fixed_payroll) > 0)) {
                        return null;
                    }
                    return <Currency quantity={getRowSalesTax(row.original)} currency="USD" />;
                },
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => {
                    const total = table.getFilteredRowModel().rows.reduce((sum, row) => sum + getRowSalesTax(row.original), 0);
                    return <Currency quantity={total} currency="USD" />;
                },
            },

            {
                accessorKey: "bill",
                header: "Bill Amount (USD)",
                cell: ({ row }) => <Currency quantity={getRowBillAmount(row.original) + getRowSalesTax(row.original)} currency="USD" />,
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => {
                    const total = table.getFilteredRowModel().rows.reduce((sum, row) => sum + getRowBillAmount(row.original) + getRowSalesTax(row.original), 0);
                    return <Currency quantity={total} currency="USD" />;
                },
            },

            {
                accessorKey: "payment",
                header: "Amount Received (USD)",
                cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
                // enableHiding: false,
                enableColumnFilter: false,
                enableGrouping: false,
                // columnVisibility: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => (
                    <>
                        {/* <span className="text-xs font-normal">Total Payment Received</span>
                        <br /> */}
                        {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.payment, 0)) || 0} currency="USD" /> */}

                        <Currency
                            quantity={table
                                .getFilteredRowModel()
                                .rows.map((row) => Number(row.original.payment))
                                .filter((val) => !isNaN(val))
                                .reduce((total, val) => total + val, 0)}
                            currency="USD"
                        />
                    </>
                ),
            },

            {
                accessorKey: "diff",
                header: "Balance (USD)",
                cell: ({ row }) => <Currency quantity={getRowBalance(row.original)} currency="USD" />,
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
                footer: ({ table }) => {
                    const total = table.getFilteredRowModel().rows.reduce((sum, row) => sum + getRowBalance(row.original), 0);
                    return <Currency quantity={total} currency="USD" />;
                },
            },

            // {
            //     accessorKey: "billPerDay",
            //     header: "Bill Per Day (USD)",
            //     cell: (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
            //     // cell: ({ row }) => (
            //     //     <> <Currency quantity={row.original.diff || 0} currency="USD" /> </>
            //     // ),
            //     // (info) => <Currency quantity={Number(info.getValue()) || 0} currency="USD" />,
            //     // enableHiding: false,
            //     enableColumnFilter: false,
            //     enableGrouping: false,
            //     // columnVisibility: false,
            //     meta: {
            //         cellClassName: "text-right",
            //     },
            //     footer: ({ table }) => (
            //         <>
            //             {/* <Currency quantity={Number(table.getFilteredRowModel().rows.reduce((total, row) => total + row.original.diff, 0)) || 0} currency="USD" /> */}
            //             <Currency
            //                 quantity={table
            //                     .getFilteredRowModel()
            //                     .rows.map((row) => Number(row.original.billPerDay))
            //                     .filter((val) => !isNaN(val))
            //                     .reduce((total, val) => total + val, 0)}
            //                 currency="USD"
            //             />
            //         </>
            //     ),
            // },

            {
                accessorKey: "uuid",
                header: "",
                cell: ({ row }) => (
                    <>
                        {/* && row.original.payment > 0 */}
                        {row.original.uuid && (
                            <>
                                {/* <a target="_blank" href={`/payments/invoice/${row.original.uuid}/${row.original.m}/${row.original.year}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                    Verify <span className="sr-only">, {row.original.consultant}</span>
                                </a>
                                {" | "} */}
                                {/* href={`/payments/invoice/${row.original.uuid}/${row.original.m}/${row.original.year}`} */}

                                {/* <b>{row.original.invoice_no}</b>
                                {" | "} */}

                                {!row.original.invoice_no && (
                                    <a
                                        href="#"
                                        onClick={(e) =>
                                            generateInvoiceHandler({
                                                uuid: row.original.uuid,
                                                checkDate: new Date(moment.utc(row.original._d).format("YYYY-MM-DD HH:mm:ss")),
                                                billingPeriod: row.original.billing_period,
                                                week: Number(row.original.calendar_week),
                                                rate: row.original.prate,
                                                startDate: row.original.period_start,
                                                endDate: row.original.period_end,
                                                record: row.original,
                                                record_st_dt: row.original.record_st_dt,
                                                record_end_dt: row.original.record_end_dt,
                                            })
                                        }
                                        className="text-blue-600 no-underline hover:text-blue-900 no-line-through"
                                    >
                                        Generate Invoice <span className="sr-only">, {row.original.uuid}</span>
                                    </a>
                                )}

                                {row.original.invoice_no && (
                                    <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
                                        {row.original.billing_period === "Customized" && (
                                            <Tooltip content="View Invoice" style="dark" placement="left">
                                                <a target="_blank" rel="noreferrer" href={`/payments/invoice/${row.original.uuid}/${row.original.invoice_no}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                                    View Invoice <span className="sr-only">, {row.original.invoice_no}</span>
                                                </a>
                                            </Tooltip>
                                        )}
                                        {(row.original.billing_period === "Monthly" || row.original.billing_period === "Monthly Itemized") && (
                                            <Tooltip content="View Invoice" style="dark" placement="left">
                                                <a target="_blank" rel="noreferrer" href={`/payments/invoice/${row.original.uuid}/${row.original.m}/${row.original.year}/${row.original.invoice_no}/${row.original._d}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                                    View Invoice <span className="sr-only">, {row.original.invoice_no}</span>
                                                </a>
                                            </Tooltip>
                                        )}
                                        {row.original.billing_period === "Weekly" && (
                                            <Tooltip content="View Invoice" style="dark" placement="left">
                                                <a target="_blank" rel="noreferrer" href={`/payments/invoice/${row.original.uuid}/${moment(row.original._d).week()}/${row.original.m}/${row.original.year}/${row.original.invoice_no}/${row.original.period_start}`} className="text-blue-600 no-underline hover:text-blue-900 no-line-through">
                                                    View Invoice <span className="sr-only">, {row.original.invoice_no}</span>
                                                </a>
                                            </Tooltip>
                                        )}
                                        {/* Show Reset Invoice only if not fully paid */}
                                        {row.original.invoice_no && row.original.diff > 0 && (
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const confirmed = window.confirm(`Reset invoice ${row.original.invoice_no} for ${row.original.name}? This will clear invoice number, payment and verification fields.`);
                                                    if (!confirmed) return;

                                                    // Call API to reset invoice
                                                    resetInvoice({ uuid: row.original.uuid, invoiceNo: row.original.invoice_no, record_st_dt: row.original.record_st_dt, record_end_dt: row.original.record_end_dt, checkDate: new Date(moment(row.original._d).format("YYYY-MM-DD")) })
                                                        .then((r) => {
                                                            openSnackbar("Invoice reset successfully");
                                                            // refresh data
                                                            applyFilters(filter || { checkDate: new Date() });
                                                        })
                                                        .catch((err) => {
                                                            logger.error("resetInvoice failed:", err);
                                                            openSnackbar("Error resetting invoice");
                                                        });
                                                }}
                                                className="text-blue-600 no-underline hover:text-red-900 no-line-through"
                                                style={{ marginLeft: 0 }}
                                            >
                                                Invalidate Invoice <span className="sr-only">, {row.original.invoice_no}</span>
                                            </a>
                                        )}
                                    </span>
                                )}
                            </>
                        )}

                        {!row.original.uuid && (
                            <span className="text-center">
                                {" "}
                                <div className="block text-sm">
                                    {/*
                                     */}
                                    {/* <ToolTip tooltip="UUID Missing!"></ToolTip> */}
                                    <Tooltip content="UUID missing, please contact administrator!" style="dark" placement="left">
                                        <ExclamationCircleIcon className="w-5 h-5 text-center text-red-500" data-tooltip-target="tooltip-default" />
                                    </Tooltip>
                                </div>
                                {/* <button data-tooltip-target="tooltip-default" type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    Default tooltip
                                </button>
                                <div id="tooltip-default" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                                    Tooltip content
                                    <div className="tooltip-arrow" data-popper-arrow></div>
                                </div> */}
                            </span>
                        )}
                    </>
                ),
                // enableHiding: false,
                enableColumnFilter: false,
                enableGrouping: false,
                // columnVisibility: false,
                meta: {
                    cellClassName: "text-center",
                },
            },
            {
                accessorKey: "actions",
                header: "Actions",
                cell: ({ row }) => (
                    <>
                        {row.original.uuid && row.original.invoice_no && row.original.diff > 0 && (
                            <div className="flex">
                                {/* Verify Button */}
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        performVerify({
                                            uuid: row.original.uuid,
                                            checkDate: moment(row.original._d).toDate(),
                                        });
                                    }}
                                    className="text-blue-600 no-underline hover:text-blue-900 no-line-through"
                                    title="Verify"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12" />
                                    </svg>
                                </a>
                                {/* Payment Button */}
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        performPayment({
                                            uuid: row.original.uuid,
                                            checkDate: moment(row.original._d).toDate(),
                                            rate: row.original.prate,
                                            invoiceNo: row.original.invoice_no,
                                            payment: null, // Let the API calculate rate * hrs for each day
                                            billingPeriod: row.original.billing_period,
                                            record_st_dt: row.original.record_st_dt,
                                            record_end_dt: row.original.record_end_dt,
                                        });
                                    }}
                                    className="p-0 ml-3 text-blue-600 no-underline bg-transparent border-0 hover:text-blue-900 no-line-through"
                                    title="Pay"
                                    style={{ cursor: "pointer" }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        )}
                    </>
                ),
                enableColumnFilter: false,
                enableGrouping: false,
                meta: {
                    cellClassName: "text-right",
                },
            },
            {
                accessorKey: "invoice_no",
                header: "Invoice No.",
                // cell: (info) => info.getValue() || "-",
                cell: (info) => (
                    <span className="truncate block max-w-[220px]" title={info.getValue() || "-"}>
                        {info.getValue() || "-"}
                    </span>
                ),
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            },

            {
                accessorKey: "_ts_invoice",
                header: "Invoice Dt.",
                cell: ({ row, getValue }) => {
                    // Only show date if invoice_no exists
                    if (!row.original.invoice_no) return "-";
                    const invoiceDate = getValue();
                    return invoiceDate ? moment(invoiceDate).format("DD MMM YYYY") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            },

            {
                accessorKey: "_ts_invoice_due",
                header: "Invoice Due Dt.",
                cell: ({ row, getValue }) => {
                    if (!row.original.invoice_no) return "-";

                    const dueDate = getValue();
                    return dueDate ? moment(dueDate).format("DD MMM YYYY") : "-";
                },
                enableColumnFilter: false,
                enableGrouping: false,
                // enableSorting: true,
                footer: ({ table }) => <>{/* <span className="font-semibold text-md">Total</span> */}</>,
            },
        ],
        [clients],
    );

    // Helper to filter data for 2025 and above, and unpaid if checked
    const filteredData = React.useMemo(() => {
        console.warn("Filtering Data");
        let result = data;

        if (applyYearFilter) {
            result = result.filter((row) => Number(row.year) >= 2025);
        }
        if (showUnpaidOnly) {
            result = result.filter((row) => {
                const payment = Number(row.payment);
                return row.payment === null || row.payment === undefined || isNaN(payment) || payment === 0;
            });
        }
        if (selectedVendor !== "all") {
            result = result.filter((row) => {
                const client = clients.find((c) => String(c.id) === String(row?.cid));
                return client?.vendor === selectedVendor;
            });
        }
        if (showAgingInRedOnly) {
            result = result.filter((row) => {
                if (!row.invoice_no || !(row.diff > 0) || !row._ts_invoice_due) return false;
                const days = moment().diff(moment(row._ts_invoice_due), "days");
                return days >= 0;
            });
        }
        // Default sort: name ASC, month DESC (recent Invoice Period first)
        return result.slice().sort((a, b) => {
            // Sort by name ascending
            if (a.name?.toLowerCase() < b.name?.toLowerCase()) return -1;
            if (a.name?.toLowerCase() > b.name?.toLowerCase()) return 1;
            // If names are equal, sort by month descending (recent first)
            if (a.month && b.month) {
                // month is in format YYYY-MM
                return b.month.localeCompare(a.month);
            }
            return 0;
        });
    }, [data, applyYearFilter, showUnpaidOnly, selectedVendor, showAgingInRedOnly, clients]);

    // Utility to format all date fields in a row (add this inside your component)
    function formatDatesForDownload(row: any) {
        const dateFields = ["period_start", "period_end", "_d", "_ts_invoice", "_ts_invoice_due"];
        const formattedRow = { ...row };
        dateFields.forEach((field) => {
            if (formattedRow[field]) {
                formattedRow[field] = moment(formattedRow[field]).format("YYYY-MM-DD");
            }
        });
        return formattedRow;
    }

    // console.log("Filtered Data:", filteredData);

    useEffect(() => {
        console.log("Data changed:", data);
        console.log("Filtered Data changed:", filteredData);
    }, [data, filteredData]);

    // Filter employees based on activeStatus
    const filteredPeople = activeStatus === "all" ? people : people.filter((p) => (activeStatus === "active" ? p.active === 1 : p.active === 0));

    return (
        <main>
            <Breadcrums breadcrumLinks={paymentsGenerateInvoiceBreadcrums} commands={paymentsCommands} groups={["Actions", "Statement"]}></Breadcrums>
            <PageTitle title="Payment Invoice(s)" summary="turning services into value" preSummary="Sealing the deal with a payment invoice"></PageTitle>

            <section className={sectionClass}>
                {/* Show duplicate invoice numbers if any */}
                {/* {duplicateInvoices.length > 0 && (
                        <div className="p-3 mb-4 text-yellow-800 bg-yellow-100 border border-yellow-400 rounded">
                            <strong>Warning:</strong> Duplicate Invoice Numbers found:
                            <ul className="ml-6 list-disc">
                                {duplicateInvoices.map((inv, idx) => (
                                    <li key={idx}>{inv?.invoice_no}</li>
                                ))}
                            </ul>
                        </div>
                    )} */}
                {/* Checkbox filters in one line */}
                <div className="flex gap-6 mb-4">
                    <label className="inline-flex items-center">
                        <input type="checkbox" checked={applyYearFilter} onChange={() => setApplyYearFilter((v) => !v)} className="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox" />
                        <span className="ml-2">Show only data for 2025 and above</span>
                    </label>
                    <label className="inline-flex items-center">
                        <input type="checkbox" checked={showUnpaidOnly} onChange={() => setShowUnpaidOnly((v) => !v)} className="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox" />
                        <span className="ml-2">Show unpaid invoices only</span>
                    </label>
                    <label className="inline-flex items-center">
                        <input type="checkbox" checked={showAgingInRedOnly} onChange={() => setShowAgingInRedOnly((v) => !v)} className="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox" />
                        <span className="ml-2">Show overdue invoices only</span>
                    </label>
                </div>

                {/* Dropdown filters in one line */}
                <div className="flex w-1/2 gap-6 mb-4">
                    <div className="flex-1">
                        <label>Filter Employees(All/Active/inactive):</label>
                        <select onChange={(e) => setActiveStatus(e.target.value as "all" | "active" | "inactive")} value={activeStatus} className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All Employees</option>
                            <option value="active">Active Employees</option>
                            <option value="inactive">Inactive Employees</option>
                        </select>
                    </div>

                    {/* Vendor filter dropdown */}
                    <div className="flex-1">
                        <label>Filter by Vendor:</label>
                        <select onChange={(e) => setSelectedVendor(e.target.value)} value={selectedVendor} className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All Vendors</option>
                            {vendors.map((vendor) => (
                                <option key={vendor.vendor} value={vendor.vendor}>
                                    {vendor.vendor}
                                </option>
                            ))}
                        </select>
                        {vendors.length > 0 && <div className="mt-1 text-xs text-gray-500">{vendors.length} vendors loaded</div>}
                    </div>
                </div>

                {/* Employee filter dropdown */}
                {/* <div className="mb-4">
                        <label>Filter by Employee:</label>
                        <select onChange={(e) => setSelectedClient(e.target.value)} value={selectedClient} className="block px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm w-96 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <option value="all">All Employees</option>
                            {data && data.length > 0 && Array.from(new Set(data.map((row) => row.name).filter(Boolean))).sort().map((employee) => (
                                <option key={employee} value={employee}>{employee}</option>
                            ))}
                        </select>
                        {data && data.length > 0 && (
                            <div className="mt-1 text-xs text-gray-500">
                                {Array.from(new Set(data.map((row) => row.name).filter(Boolean))).length} unique employees found
                            </div>
                        )}
                    </div> */}

                {/* Space between filters */}
                <div className="mb-6"></div>

                {/* Pass filtered employees to CommonFilters */}
                <div className="mb-4">
                    <CommonFilters key={`${billingPeriod}-${activeStatus}-${applyYearFilter}-${selectedVendor}-${showUnpaidOnly}`} people={filteredPeople} applyFilters={applyFilters} vendorId={selectedVendor !== "all" ? selectedVendor : undefined} billingPeriod={billingPeriod} employeeStatus={activeStatus} yearLimit={applyYearFilter} />
                </div>

                <div className="mb-4">
                    <label>Filter by Billing Period:</label>
                    <select onChange={(e) => setBillingPeriod(e.target.value as "all" | "Weekly" | "Monthly" | "Monthly Itemized" | "Customized")} value={billingPeriod} className="block px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm w-96 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        <option value="all">All</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Monthly Itemized">Monthly Itemized</option>
                        <option value="Customized">Customized</option>
                    </select>
                </div>

                {/* Send Overdue and Unpaid Email Buttons */}
                <div className="flex gap-4 mb-6">
                    <OverdueEmail />
                    <UnpaidEmail />
                </div>

                {!isLoading && data && filteredData?.length > 0 && <TanstackTable key={tableKey} data={billingPeriod === "all" ? filteredData : filteredData?.filter((row) => row.billing_period?.split(',').includes(billingPeriod))} columns={columns} downloadBtn={true} formatDataForDownload={formatDatesForDownload} />}
                {!isLoading && filteredData?.length <= 0 && <div className="my-5">No records found</div>}
                {isLoading && <div className="my-5">Loading... </div>}
            </section>
        </main>
    );
}
